import React, { useEffect, useMemo } from 'react'
import ChatsMain from './ChatsMain'
import WhatAreChats from './WhatAreChats'
import OmnichannelPlatform from './OmnichannelPlatform'
import ChatFeatures from './ChatFeatures'
import ClientLoss from './ClientLoss'
import DontLoseClients from './DontLoseClients'
import ChatRisks from './ChatRisks'
import ChatBenefits from './ChatBenefits'
import OmnichannelResults from './OmnichannelResults'
import PricingDetails from './PricingDetails'
import OtherSolutions from './OtherSolutions'
import CompaniesUsingService from './CompaniesUsingService'
import StillHaveQuestions from './StillHaveQuestions'
import ChatsFAQ from './ChatsFAQ'
import { ReviewsScreen } from '~/components/common/reviews-screen'
import { CrmsScreen } from '~/components/common/crms-screen'
import { StyledScreen } from '~common/screen'
import { useAppSelector } from "~/hooks/redux"
import { priceService } from "~/store/price/price-service"

interface ICurrency {
  [key: string]: string
}

interface CurrencyItem {
  cost: number
  currency: string
}

const ChatsPage = () => {
  const { country } = useAppSelector(state => state.countryReducer)
  const { data: services, isLoading } = priceService.useGetPricesQuery('')
  const currencyObj: ICurrency = {
    RU: '₽',
    UZ: 'сум',
    KZ: '₸',
  }

  const prepareChatsServiceCost = (serviceCosts: any) => {
    if (!serviceCosts) return {}

    return serviceCosts.reduce((acc: any, current: CurrencyItem) => {
      return { ...acc, [current.currency]: current }
    }, {})
  }

  const chatsPrice = useMemo(() => {
    const whatsAppServiceCost = prepareChatsServiceCost(services?.find(service => service.type === 'CHATS_WHATSAPP').cost_in_currency_per_day)
    const telegramServiceCost = prepareChatsServiceCost(services?.find(service => service.type === 'CHATS_TELEGRAM').cost_in_currency_per_day)

    const whatsApp = {
      currency: currencyObj[country.value],
      summ: Math.round((whatsAppServiceCost[country.currency]?.cost || 0) / 100 * 30)
    }
    const telegram = {
      currency: currencyObj[country.value],
      summ: Math.round((telegramServiceCost[country.currency]?.cost || 0) / 100 * 5 * 30)
    }

    return {
      whatsApp,
      telegram
    }
  }, [country, services])

  return (
    <>
      <ChatsMain />
      <WhatAreChats />
      <OmnichannelPlatform />
      <ChatFeatures />
      <ClientLoss />
      <DontLoseClients />
      <ChatRisks />
      <ChatBenefits />
      <OmnichannelResults />
      <PricingDetails price={chatsPrice} country={country.value} />
      <OtherSolutions />
      <CompaniesUsingService country={country.value} />
      <CrmsScreen
        title={<span><StyledScreen.GreenText>30+</StyledScreen.GreenText> интеграций с партнерами</span>}
        screenProps={{ bottomLine: true }}
      />
      <ReviewsScreen />
      <ChatsFAQ />
      <StillHaveQuestions />
    </>
  )
}

export default ChatsPage